import {
    FEATURES,
    hasFeature,
    hasFeatureGrant,
    IMy,
} from "../../../entities/my";

export const getStaffPermissions = (my: IMy, targetUserId?: number) => {
    const canReadWorkTgs = hasFeature(my, FEATURES.WORK_TGS.LIST)
    const canUpdateStaff = hasFeature(my, FEATURES.IDM.PERSONAL_UPDATE, targetUserId)
    const canUpdateStaffWorkTgs = canReadWorkTgs
        && hasFeature(my, FEATURES.IDM.WORK_TGS_UPDATE, targetUserId)
    const canTutorPenaltyBonus =
        hasFeature(my, FEATURES.TUTORS.PENALTIES_BONUSES_CREATE, targetUserId)
        || hasFeature(my, FEATURES.TUTORS.PENALTIES_BONUSES_READ, targetUserId)
    const canTutorPayouts =
        hasFeature(my, FEATURES.TUTORS.PAYOUTS_CREATE, targetUserId)
        || hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, targetUserId)
        || hasFeature(my, FEATURES.TUTORS.RECEIPTS_READ, targetUserId)

    return {
        isListAvailable: hasFeatureGrant(my, FEATURES.IDM.STAFF_LIST),
        canReadIdmStaff: hasFeature(my, FEATURES.IDM.STAFF_READ, targetUserId),
        canListRoles: hasFeature(my, FEATURES.IDM.ROLES_LIST),
        canListUserFeatures: hasFeature(my, FEATURES.IDM.USER_FEATURES_LIST, targetUserId),
        canListAvailableFeatures: hasFeature(my, FEATURES.IDM.USER_AVAILABLE_FEATURES_LIST, targetUserId),
        canReadWorkTgs,
        canMoveStaffWorkTg: canUpdateStaffWorkTgs,
        canCreateStaff: hasFeature(my, FEATURES.IDM.STAFF_CREATE),
        canEditStaff: canUpdateStaff || canUpdateStaffWorkTgs,
        canResetStaffPassword: hasFeature(my, FEATURES.IDM.USER_PASSWORD_RESET, targetUserId),
        canDeleteStaff: hasFeature(my, FEATURES.IDM.STAFF_DELETE, targetUserId),
        canArchiveStaff: hasFeature(my, FEATURES.IDM.STAFF_ARCHIVE, targetUserId),
        canUnarchiveStaff: hasFeature(my, FEATURES.IDM.STAFF_UNARCHIVE, targetUserId)
            || hasFeature(my, FEATURES.IDM.STAFF_ARCHIVE, targetUserId),
        canAssignUserRoles: hasFeature(my, FEATURES.IDM.USER_ROLES_ASSIGN, targetUserId),
        canRemoveUserRoles: hasFeature(my, FEATURES.IDM.USER_ROLES_REMOVE, targetUserId),
        canGrantUserFeatures: hasFeature(my, FEATURES.IDM.USER_FEATURES_GRANT, targetUserId),
        canRevokeUserFeatures: hasFeature(my, FEATURES.IDM.USER_FEATURES_REVOKE, targetUserId),
        canAssistantPenaltyCreate: hasFeature(my, FEATURES.IDM.PENALTIES_BONUSES_CREATE, targetUserId),
        canAssistantPenaltyRead: hasFeature(my, FEATURES.IDM.PENALTIES_BONUSES_READ, targetUserId),
        canTutorFinanceRead: hasFeature(my, FEATURES.TUTORS.FINANCE_READ, targetUserId),
        canTutorStudentsView: hasFeature(my, FEATURES.TUTORS.STUDENTS_READ, targetUserId),
        canReadTutorReceipts: hasFeatureGrant(my, FEATURES.TUTORS.RECEIPTS_READ),
        canTutorPenaltyBonus,
        canTutorPayouts,
    }
}

export type TStaffPermissions = ReturnType<typeof getStaffPermissions>
